<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <SPIFProfileHeader  :headerData="this.headerData"/>

      <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-section-start">
            <div>
              <h1 class="md-title profile-title">Valuation Multiples</h1>
            </div>
          </div>
        </div>
      </div> -->

      <div class="md-layout-item p-0">
        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>query_stats</md-icon>
            </div>
            <h4 class="title text-left">
              [238220 Plumbing, Heating, and Air Conditioning Contractors <br />
              <small
                >Valuations are derived from closed business sales as well as
                enterprise-level revenue and industry financial analysis
                developed by Bizminer.
              </small>
            </h4>
          </md-card-header> -->
          <div class="md-layout md-card if_card">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header md-card-header-icon">
                <div class="card_icon">
                  <md-icon>light_mode</md-icon>
                </div>
                About Valuation Multiples
              </md-card-header>
              <div class="md-card-content">
                <div class="extra_space">
                  <p>
                    Mauris urna est, tempus vel lectus non, convallis fringilla
                    ligula. Proin varius lobortis nibh, at dignissim sem
                    dignissim eu. Ut eget lacus at erat lobortis elementum.
                    Praesent id iaculis ex. Donec interdum condimentum velit
                    quis rutrum. Quisque consequat mattis libero eget commodo.
                    Fusce tristique pharetra purus commodo eleifend. Maecenas
                    consequat luctus nulla, ac malesuada mauris semper in. Nulla
                    pretium fringilla rhoncus. Nam suscipit faucibus libero, ac
                    ultricies ipsum blandit vel. Vivamus non mauris ac arcu
                    aliquam accumsan vitae a risus.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <md-card-content class="p-0 negetive_margin">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                        <i class="md-icon md-icon-font md-theme-default"
                          >receipt</i
                        >
                      </div> -->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >
                          Sales Group: &#60; $2.5m
                        </div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table
                            v-model="tableInfo"
                            table-header-color="blue"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="">
                                <div class="md-table-side-label">
                                  {{ item.name }}
                                </div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">{{
                                multiplesA ? multiplesA[`Sales${item.id}`] : ''
                              }}</md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">{{
                                multiplesA
                                  ? multiplesA[`Earnings${item.id}`]
                                  : ''
                              }}</md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                    </div> -->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >
                          Sales Group: $2.5m - $24.9m
                        </div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table
                            v-model="tableInfo"
                            table-header-color="blue"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="">
                                <div class="md-table-side-label">
                                  {{ item.name }}
                                </div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">{{
                                multiplesB ? multiplesB[`Sales${item.id}`] : ''
                              }}</md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">{{
                                multiplesB
                                  ? multiplesB[`Earnings${item.id}`]
                                  : ''
                              }}</md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                    </div> -->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >
                          Sales Group: &#62; $25m
                        </div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table
                            v-model="tableInfo"
                            table-header-color="blue"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="">
                                <div class="md-table-side-label">
                                  {{ item.name }}
                                </div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">{{
                                multiplesC ? multiplesC[`Sales${item.id}`] : ''
                              }}</md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">{{
                                multiplesC
                                  ? multiplesC[`Earnings${item.id}`]
                                  : ''
                              }}</md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                    </div> -->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >
                          Sales Group: All
                        </div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table
                            v-model="tableInfo"
                            table-header-color="blue"
                          >
                            <md-table-row
                              slot="md-table-row"
                              slot-scope="{ item }"
                            >
                              <md-table-cell md-label="">
                                <div class="md-table-side-label">
                                  {{ item.name }}
                                </div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">{{
                                multiplesAll
                                  ? multiplesAll[`Sales${item.id}`]
                                  : ''
                              }}</md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">{{
                                multiplesAll
                                  ? multiplesAll[`Earnings${item.id}`]
                                  : ''
                              }}</md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>


    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';

export default {
  components: {
    SPIFProfileHeader,
    TableCard,
  },
  props: ['headerData'],
  data() {
    return {
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      multiplesA: (state) => {
        return state.user.profile.data['multiples_A'] &&
          state.user.profile.data['multiples_A'] != ''
          ? state.user.profile.data['multiples_A']
          : [];
      },
      multiplesB: (state) => {
        return state.user.profile.data['multiples_B'] &&
          state.user.profile.data['multiples_B'] != ''
          ? state.user.profile.data['multiples_B']
          : [];
      },
      multiplesC: (state) => {
        return state.user.profile.data['multiples_C'] &&
          state.user.profile.data['multiples_C'] != ''
          ? state.user.profile.data['multiples_C']
          : [];
      },
      multiplesAll: (state) => {
        return state.user.profile.data['multiples_all'] &&
          state.user.profile.data['multiples_all'] != ''
          ? state.user.profile.data['multiples_all']
          : [];
      },
    }),
  },
  methods: {},
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
